import React from 'react';
import { useAppSelector } from 'store/hooks';

import { COURSE_TYPES } from 'constants/common';

import * as api from 'api/methods';

import {
  getDailyChallenges,
  removeDailyChallengeById,
} from 'store/dailyChallenges/actions';
import { dailyChallengesSelector } from 'store/dailyChallenges/selectors';

import { useCourses } from 'hooks/useCourses';

import { getTranslation } from 'helpers/getTranslation';

import { DefaultModal } from 'components/DefaultModal';
import { RemoveWithStepsModal } from 'components/RemoveWithStepsModal';

import { CreateDailyChallenge } from './components/CreateDailyChallenge';

import DailyChallengesPage from './DailyChallengesPage';

const DailyChallengesPageContainer = () => {
  const dailyChallenges = useAppSelector(dailyChallengesSelector);

  const {
    loading,
    isRootAdmin,
    createOpen,
    removeOpen,
    removeConfirmOpen,
    sortParams,
    columns,
    removeConfirmData,
    removeData,
    closeCreate,
    closeRemoveConfirm,
    closeRemove,
    onSearchChange,
    onSortChange,
    onContextItemClick,
    onRowClick,
    onEditClick,
    onRemoveClick,
    onConfirmRemoveClick,
    onCreateClick,
  } = useCourses({
    getItems: getDailyChallenges,
    removeItemById: removeDailyChallengeById,
    createItem: api.createDailyChallenge,
    itemsPerPage: dailyChallenges.perPage,
    type: COURSE_TYPES.DAILY_CHALLENGE,
    pathPrefix: '/daily-challenges',
  });

  return (
    <>
      <DailyChallengesPage
        loading={loading}
        isRootAdmin={isRootAdmin}
        dailyChallenges={dailyChallenges.data}
        sortParams={sortParams}
        columns={columns}
        onSearchChange={onSearchChange}
        onSortChange={onSortChange}
        onContextItemClick={onContextItemClick}
        onRowClick={onRowClick}
        onEditClick={onEditClick}
        onRemoveClick={onRemoveClick}
        onCreateClick={onCreateClick}
      />
      <CreateDailyChallenge open={createOpen} onClose={closeCreate} />
      <DefaultModal
        {...removeConfirmData}
        open={removeConfirmOpen}
        confirmText={getTranslation('trainings_page.confirm_text')}
        onConfirmClick={onConfirmRemoveClick}
        onCancelClick={closeRemoveConfirm}
        onClose={closeRemoveConfirm}
      />
      <RemoveWithStepsModal
        {...removeData}
        open={removeOpen}
        variant="DAILY_CHALLENGE"
        title={getTranslation('trainings_page.remove_modal_title')}
        onClose={closeRemove}
      />
    </>
  );
};

export default React.memo(DailyChallengesPageContainer) as any;
